module.exports = __webpack_public_path__ + "img/Insiders Icon - white.b545715a.svg";